type GetAdjBasePrice = (meta: { [key: string]: any }) => number | null

export const getAdjBasePrice: GetAdjBasePrice = ({ price, originalPrice }) => {
  if (price < originalPrice) return price

  return null
}
